<!-- Main Overlay -->
<mg-overlay-primary
  size="auto"
  [isLoading]="isLoading$ | async"
  [bodyNoPadding]="true"
  [overlayTitle]="dialogData.currentInstanceId ? MSG.MODAL_TITLE : MSG.MODAL_TITLE_NEW">
  <ng-container *ngTemplateOutlet="mainTemplate"></ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</mg-overlay-primary>

<!-- Main Content Template -->
<ng-template #mainTemplate>
  <main class="modal-form">
    <section class="tw-grid tw-grid-cols-1 tw-gap-3">
      <section class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-column-gap-4 tw-row-gap-3">
        <div
          *ngIf="!dialogData.myActivities && (teacherOptions$ | async)?.length > 0"
          class="filter">
          <mg-form-select
            [placeholder]="MSG.TEACHER_FILTER_LABEL"
            [searchable]="true"
            [floatingLabel]="true"
            [isClearable]="true"
            [options]="teacherOptions$ | async"
            [control]="form.controls.teacherFilter">
          </mg-form-select>
        </div>
        <div class="filter">
          <mg-form-text-input
            [label]="MSG.TEXT_FILTER_LABEL"
            [isClearable]="true"
            [control]="form.controls.searchFilter">
          </mg-form-text-input>
        </div>
      </section>
      <section>
        <mg-ftm-activity-selector-list
          [activities]="filteredActivities$ | async"
          [activityCardFields]="CARD_FIELDS"
          [selectedId]="form.controls.flexTimeActivity.value?.id || (existingActivity$ | async)?.id"
          (activitySelected)="setActive($event)">
          <ng-template #noResults>
            <!-- Empty State -->
            <mg-empty-state
              *ngIf="!(filteredActivities$ | async)?.length && (isLoading$ | async) !== true"
              actionButtonLabel="Go There"
              [title]="MSG.EMPTY_STATE_TITLE"
              [subtitle]="MSG.EMPTY_STATE_SUBTITLE"
              (handleAction)="goToActivityTemplate()">
            </mg-empty-state>
          </ng-template>
        </mg-ftm-activity-selector-list>
      </section>
    </section>
  </main>
</ng-template>

<!-- Footer Content Templat -->
<ng-template #footerTemplate>
  <footer
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div>
      <mg-btn
        *ngIf="dialogData.currentInstanceId; else cancelBtn"
        variant="destructive"
        (pressed)="remove()">
        {{ MSG.BUTTON_LABEL_REMOVE }}
      </mg-btn>
      <ng-template #cancelBtn>
        <mg-btn
          variant="text"
          (pressed)="cancel()">
          {{ MSG.BUTTON_LABEL_CANCEL }}
        </mg-btn>
      </ng-template>
    </div>
    <div>
      <mg-btn
        variant="filled"
        [disabled]="form.invalid"
        (pressed)="submit()">
        {{ MSG.BUTTON_LABEL_ADD }}
      </mg-btn>
    </div>
  </footer>
</ng-template>
